module.exports = __webpack_public_path__ + "6174e079d2219b9e0ce909996520041f.svg";